import { gql } from "@apollo/client";

/**
 * Local copy of `services/graphQL/mutations.ts#MUTATION_SEND_FEATURE_WF_INVITE`
 * for the internal SC-request page.
 *
 * It is identical to the shared mutation except it adds an `is_dummy` argument
 * (always sent as `true` from this page) alongside `sendEstimateInviteData`, so
 * these requests are flagged as dummy on the backend. Kept local — rather than
 * modifying the shared mutation — so the existing request-durations callers stay
 * untouched.
 */
export const MUTATION_SEND_SC_REQUEST_DUMMY_INVITE = gql`
  mutation sendScRequestDummyFeatureWorkflowInvite(
    $sendEstimateInviteData: [sendEstimateInviteInput!]!
    $is_dummy: Boolean!
  ) {
    send_estimate_invite(
      sendEstimateInviteData: $sendEstimateInviteData
      is_dummy: $is_dummy
    ) {
      message
      response {
        token
        invite_id
      }
    }
  }
`;
